import React, {useEffect, useRef, useState} from 'react';
import Header from '../../admin/component/header/Header';
import {Row, Col, Form, Button,} from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import {Link, useHistory} from 'react-router-dom';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import {Editor} from '@tinymce/tinymce-react';
import axios from 'axios';
import $ from "jquery";
import MaintainenceLogout from '../../components/logout/MaintainenceLogout';
import SessionExpiredAdmin from '../../components/SessionExpired/SessionExpiredAdmin'
import { makeStyles } from '@material-ui/core/styles';
import Back from '../../assets/images/Back_white.png'

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

const ReadMe = () => {
    const history = useHistory()
    const [deletebtnDisable, setDeletebtnDisable] = useState(false)
    const [readmeGet, setreadmeGet] = useState([])
    const [theHeader, setTheHeader] = useState('');
    const [theText, setTheText] = useState('')
    const [readmeRow, setreadmeRowID] = useState(localStorage.getItem('readmeRowID'))
    const [statusReadMe, setstatusReadMe] = useState(0)
    const [fData, setFData] = useState(true)
    const [on, seton] = useState()
    const [previewDisAble, setPreviewDisAble] = useState(false)
    const [ReadMeStatusActiveLS, setTermStatusActiveLS] = useState(localStorage.getItem("readMeStatusActive"))
    const [theHeaderReadMeEditor, settheHeaderReadMeEditor] = useState(localStorage.getItem("readMetheHeaderEditor"))
    const [theReadMeTextLS, settheReadMeTextLS] = useState(localStorage.getItem("theReadMeText"))
    const [TokenExpired, setTokenExpired] = useState(false);


    //new
    const [sRecordType, setsRecordType] = useState('README')
    const [nReturnID,setnReturnID] = useState('')

    const [isSaved, setIsSaved] = useState(false)

    const [open, setOpen] = React.useState(false);
    const classes = useStyles();

    const handleClose = () => {
        setOpen(false);
    };

    // get Data
    const columns = [
        {
            dataField: 'theheader',
            text: 'Version',
            style: (cell, row, rowIndex, colIndex) => {
                if (row.id === readmeRow) {
                    return {
                        backgroundColor: '#F0F8FF'
                    };
                }
            }, formatter: (cell) => {
                if (cell) {
                    return (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: cell
                            }}
                        />
                    );
                }
            },
            sort: true
        }, {
            dataField: 'statusid',
            text: 'Status',
            formatter: (cell) => {
                if (cell == "1") {
                    return (
                        <span>
                            <strong style={{color: '#28a745'}}> Active </strong>
                        </span>
                    );
                } else {
                    return (
                        <span>
                            <strong style={{color: '#dc3545'}}> In Active </strong>
                        </span>
                    );
                }
            },
            style: (cell, row, rowIndex, colIndex) => {
                if (row.id === readmeRow) {
                    return {
                        backgroundColor: '#F0F8FF'
                    };
                }
            },
            sort: true
        }, {
            dataField: 'created',
            text: 'Created',
            formatter: (cell) => {
                let dateObj = cell;
                if (typeof cell !== 'object') {
                    dateObj = new Date(cell);
                }
                return cell;
            },
            sortValue: (cell) => {
                let dateObj = cell;
                if (typeof cell !== 'object') {
                    dateObj = new Date(cell).getTime();
                }
                return dateObj;
            },
            style: (cell, row, rowIndex, colIndex) => {
                if (row.id === readmeRow) {
                    return {
                        backgroundColor: '#F0F8FF'
                    };
                }
            },
            sort: true

        }, {
            dataField: 'updated',
            text: 'Updated',
            formatter: (cell) => {
                let dateObj = cell;
                if (typeof cell !== 'object') {
                    dateObj = new Date(cell);
                }
                return cell;
            },
            sortValue: (cell) => {
                let dateObj = cell;
                if (typeof cell !== 'object') {
                    dateObj = new Date(cell).getTime();
                }
                return dateObj;
            },
            style: (cell, row, rowIndex, colIndex) => {
                if (row.id === readmeRow) {
                    return {
                        backgroundColor: '#F0F8FF'
                    };
                }
            },
            sort: true
        }
    ];

    function getPolicyQuestion() {
        setOpen(true)
        axios.get(`${process.env.REACT_APP_SERVICE_PLAN_API}readme?nWhichScreen=0`)
            .then(function (response) {
                if (response.data.status) {
                    setTokenExpired(true)
                }else {
                    setreadmeGet(response.data)
                    setOpen(false)
                }
            })
    }

    useEffect(() => {
        getPolicyQuestion()
    }, [])
    // localStorage
    useEffect(() => {
        if (ReadMeStatusActiveLS && theHeaderReadMeEditor && theReadMeTextLS) {
            setstatusReadMe(ReadMeStatusActiveLS)
            setTheHeader(theHeaderReadMeEditor);
            setTheText(theReadMeTextLS);

            if (ReadMeStatusActiveLS == 1) {
                $(`#formBasicCheckbox`).prop("checked", true)
                setstatusReadMe(ReadMeStatusActiveLS)
            }
        }
    }, [])


    // edirot header
    const handleEditorChange = (value, editor) => {
        setTheHeader(value)
    }
    // editor theText Body
    const handleEditorChangetheText = (value, editor) => {
        setTheText(value)
    }

    // Table Row Selected
    const rowEvents = {
        onClick: (e, row) => {
            getPolicyQuestion()
            setPreviewDisAble(true)
            setTheHeader(row.theheader)
            setTheText(row.thetext)
            setsRecordType(row.sRecordType)
            setnReturnID(row.nReturnID)
            console.log(row.id)
            setreadmeRowID(row.id)
            setDeletebtnDisable(true)
            localStorage.setItem('editbtnPolicy', true)
            if (row.statusid == 1) {
                $(`#formBasicCheckbox`).prop("checked", true)
                setstatusReadMe(row.statusid)
            } else {
                $(`#formBasicCheckbox`).prop("checked", false)
                setstatusReadMe(row.statusid)
            }
        }
    }
    // checkbox
    const checkboxChanger = (e) => {
        let target = e.target;
        if (target.checked) {
            setstatusReadMe(1)
        } else {
            setstatusReadMe(0)
            localStorage.setItem('readMeStatusActive', 0)
        }
    }

    // Preview
    function hnadlerPreviewbtn() {
        localStorage.setItem('readMetheHeaderEditor', theHeader);
        localStorage.setItem('theReadMeText', theText);
        localStorage.setItem('readMeStatusActive', statusReadMe);
        localStorage.setItem("readmeRowID", readmeRow);
    }

    // Add New Btn
    const newButtonClick = () => {
        setPreviewDisAble(false)
        setTheHeader('')
        setTheText('')
        setsRecordType('')
        setnReturnID('')
        setstatusReadMe(1)
        setDeletebtnDisable(false)
        setFData(true)

        if (document.getElementById('demo_ifr').focus()) {
            setPreviewDisAble(false)
        }
        document.getElementById('demo_ifr').focus()
        $(`#formBasicCheckbox`).prop("checked", true)
        localStorage.setItem('PreviewDisAble', false)
        localStorage.setItem('readMetheHeaderEditor', '')
        localStorage.setItem('theReadMeText', '')
        localStorage.setItem('readMeStatusActive', 1)
        localStorage.setItem('editbtnPolicy', false)
        localStorage.setItem("readmeRowID", '')
    }
    // delete

    const deleteButtonClicked = () => {

        console.log(readmeRow)
        const data = {
            nID: readmeRow,
        };
        var token = localStorage.getItem('maintenance-token');
        axios.post(process.env.REACT_APP_SERVICE_PLAN_API + 'page/privacypolicydelete', data,
            {headers: {Authorization: `Bearer ${token}`}}
        ).then(res => {
            if (res.data.status) {
                setTokenExpired(true)
            }else {
                setTheHeader('')
                setTheText('')
                setsRecordType('')
                setnReturnID('')
                $(`#formBasicCheckbox`).prop("checked", false)
                document.getElementById('demo_ifr').focus()
                localStorage.setItem("readMeStatusActive", '')
                localStorage.setItem("readMetheHeaderEditor", '')
                localStorage.setItem("theReadMeText", '')
                localStorage.setItem("readmeRowID", '')
                localStorage.setItem('editbtnPolicy', false)
                getPolicyQuestion()
            }
        }).catch(err => {
            console.log(err);

        });


    }
    // submit
    const termsSubmitHandler = (e) => {
        setIsSaved(true)
        e.preventDefault()
        let editBtn = localStorage.getItem('editbtnPolicy')
        console.log(editBtn == "false")
        if (editBtn == "false") {
            const data = {
                nID: '',
                sHeader: theHeader,
                sText: theText,
                nIsActive: statusReadMe,
                sRecordType:sRecordType,
                nReturnID:nReturnID
            }
            var token = localStorage.getItem('maintenance-token');
            axios.post(`${process.env.REACT_APP_SERVICE_PLAN_API}page/readmesave`, data,
                {headers: {Authorization: `Bearer ${token}`}}
            ).then(res => {
                if (res.data.status) {
                    setTokenExpired(true)
                }else {
                    setIsSaved(false)
                    console.log("added data new")
                    setDeletebtnDisable(false)
                    setTheHeader('')
                    setTheText('')
                    setsRecordType('')
                    setnReturnID('')
                    $(`#formBasicCheckbox`).prop("checked", false)
                    localStorage.setItem("readMeStatusActive", '')
                    localStorage.setItem("readMetheHeaderEditor", '')
                    localStorage.setItem("theReadMeText", '')
                    localStorage.setItem("readmeRowID", '')
                    localStorage.setItem('editbtnPolicy', false)
                    getPolicyQuestion()
                }
            }).catch(err => {
                console.log(err);

            });
        } else {
            const data = {
                nID: readmeRow == '' ? localStorage.getItem("readmeRowID") : readmeRow,
                sHeader: theHeader,
                sText: theText,
                nIsActive: statusReadMe,
                sRecordType:sRecordType,
                nReturnID:nReturnID
            }
            console.log("Edit Add")
            console.log(data)
            var token = localStorage.getItem('maintenance-token');
            axios.post(`${process.env.REACT_APP_SERVICE_PLAN_API}page/readmesave`, data,
                {headers: {Authorization: `Bearer ${token}`}}
            ).then(res => {
                if (res.data.status) {
                    setTokenExpired(true)
                }else {
                    setDeletebtnDisable(false)
                    setTheHeader('')
                    setTheText('')
                    setsRecordType('')
                    setnReturnID('')
                    $(`#formBasicCheckbox`).prop("checked", false)
                    localStorage.setItem("readMeStatusActive", '')
                    localStorage.setItem("readMetheHeaderEditor", '')
                    localStorage.setItem("theReadMeText", '')
                    localStorage.setItem("readmeRowID", '')
                    localStorage.setItem('editbtnPolicy', false)
                    getPolicyQuestion()
                }
            }).catch(err => {
                console.log(err);

            });
        }
        getPolicyQuestion()
    }

    function BackBtnfun() {
        $(`#formBasicCheckbox`).prop("checked", false)
        localStorage.setItem("readMeStatusActive", '')
        localStorage.setItem("readMetheHeaderEditor", '')
        localStorage.setItem("theReadMeText", '')
        localStorage.setItem("readmeRowID", '')
        localStorage.setItem('editbtnPolicy', false)
        history.push("/maintenance")
    }

    return (
        <>
            {
                TokenExpired
                && <SessionExpiredAdmin/>
            }

            <section className="faq-main-section terms-of-use-main-section common-font-section">
                <Header title=" Read Me"/>
                <Row className="mx-auto text-center mobile-button back-logout-btn">
                    <Col
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        className="p-2 text-start profile-left-btn d-flex btnall"
                    >
                        <Link to="/maintenance" className="btn custom-link btn-primary">
                            <img src={Back} alt="Back" className="w-5"/> Back
                        </Link>
                    </Col>
                    <Col
                        lg={6} md={6} sm={6} xs={6} className="btnall"
                    >
                        <MaintainenceLogout/>
                    </Col>
                </Row>
                <div className="faq-inner-content">
                    <div className="divider-mobile"></div>
                    <Row className="mx-auto text-center pt-4 mobile-direction terms-of-use-table inner-table-form">
                        <Col lg={5} md={12} className="p-2 right-side-table " id="style-2">
                            <BootstrapTable keyField='id' rowClasses="custom-row-class0" hover data={readmeGet}
                                            columns={columns} rowEvents={rowEvents}/>
                        </Col>
                        <div className="divider-mobile"></div>
                        <Col lg={7} md={12} className="p-2">
                            <div className="Service-plan-addsection">

                                <Form onSubmit={(e) => termsSubmitHandler(e)} className="form-faq-section ">
                                    <Form.Group controlId="formBasicCheckbox"
                                                className="from-group-section active-status">
                                        <Form.Label>Status:</Form.Label>
                                        <Form.Check type="checkbox" label="Is Active" className="Checked-box"
                                                    onChange={e => checkboxChanger(e)}/>
                                    </Form.Group>
                                    <Form.Group className=" editor-data-new">
                                        <div className="terms-of-use-add-delet-btn">
                                            <Form.Label>Header:</Form.Label>
                                            <div className="add-button-section">
                                                <Button className="btn btn-success" onClick={newButtonClick}>Add New
                                                    Item</Button>
                                                {
                                                    deletebtnDisable ?
                                                        <Button variant="danger" onClick={() => {
                                                            const confirmBox = window.confirm(
                                                                "Are you sure you want to delete the selected record?"
                                                            )
                                                            if (confirmBox === true) {
                                                                deleteButtonClicked()
                                                            }
                                                        }}>Delete</Button>
                                                        :
                                                        <Button className="btn btn-danger disable-btn-delete"
                                                                disabled>Delete</Button>
                                                }
                                            </div>
                                        </div>
                                        <Editor apiKey='0uwj75xw3ds611tc44hl9n9o0sc6yemx1h8rgnxbyd6bzbmu'
                                                value={theHeader}
                                                id="demo"
                                                init={{
                                                    plugins: " fullpage  fullscreen  link advlist lists  ",
                                                    toolbar: " bold italic underline strikethrough | fontselect | fontsizeselect | formatselect | lineheight|alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor | casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment",
                                                }}
                                                onEditorChange={handleEditorChange}
                                        />
                                    </Form.Group>
                                    <Form.Group className="preview-editor-sec-enw">
                                        <div className="d-flex justify-content-between align-items-baseline">
                                            <Form.Label className="m-0 ">Body:</Form.Label>

                                            {
                                                previewDisAble ?
                                                    <Form.Label><Link to="/privacy-policy-preview"
                                                                      onClick={() => hnadlerPreviewbtn()}
                                                                      className="btn float-right preview-btn btn-danger  m-0">Preview</Link></Form.Label>
                                                    :
                                                    <Button className="btn btn-danger disable-btn-delete preview"
                                                            disabled>Preview</Button>
                                            }
                                        </div>
                                        <Editor apiKey='0uwj75xw3ds611tc44hl9n9o0sc6yemx1h8rgnxbyd6bzbmu'
                                                value={theText}
                                                init={{
                                                    plugins: "  fullpage  fullscreen  link advlist lists  ",
                                                    toolbar: " bold italic underline strikethrough | fontselect | fontsizeselect | formatselect | lineheight|alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor | casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment",
                                                }}
                                                onEditorChange={handleEditorChangetheText}
                                        />
                                    </Form.Group>
                                    <Button className="submite-button " type="submit" style={{height:'45px'}}>
                                        Save
                                    </Button>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
        </>
    )
}
export default ReadMe
